var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',{staticClass:"d-flex"},[_c('input-checkbox',{attrs:{"required":""},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}}),_c('p',[_vm._v(_vm._s(_vm.$t("FICHA_SAUDE.DECLARAR_VERDADEIRO")))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }